<div class="d-flex justify-content-between w-100">
  <div class="d-flex flex-column gap-2">
    <span class="instruction-card-value">{{ frequency | vbPaymentChangeRecurringPaymentFrequencyLabel }}</span>
    <div class="instruction-card-payment-label" i18n>Payment Starts {{ paymentStartLabel }}</div>
  </div>
  <div class="d-flex flex-column gap-2">
    <span class="instruction-card-value" i18n>{{
      scheduledRecurringPaymentInstruction?.paymentAmount
        | recurringPaymentFrequency : scheduledRecurringPaymentInstruction?.paymentFrequencyId
    }}</span>
    <div class="instruction-card-payment-label" [style.margin-left]="'auto'" i18n>{{ paymentAmountType }}</div>
  </div>
</div>
